import type { User, UserPerspective } from './types';

/**
 * De perspectieven waartussen de gebruiker kan wisselen. Leeg bij nul of één
 * perspectief — dan toont de UserBadge geen keuze.
 */
export function switchablePerspectives(user: Pick<User, 'perspectives'>): UserPerspective[] {
  return user.perspectives.length > 1 ? user.perspectives : [];
}
